<template>
    <div class="order-pictures">
        <b-form-group   id="categoryInputGroup"
                        horizontal
                        :label-cols="3"
                        label="Galeriekategorien: * "            
                        label-for="categoryInput">
            <b-form-select id="categoryInput"
                           v-model="selected"
                           :options="categories">
            </b-form-select>
            <div @click="categoryPictures" class="butn">load</div>
        </b-form-group> 

        <div v-for="(picture, i) in pictures" :key="picture.id" class="picture-card cf">
            <b-img :src="picture.url"></b-img>
            <div class="order-picture">
                <div @click="switchPosition(i, -1)" class="up butn">up</div>
                <div @click="switchPosition(i, 1)" v-if="i < pictures_length" class="down butn">down</div>
            </div>
        </div>
        <div @click="onSubmit" class="butn">Reihenfolge anpassen</div>
    </div>
</template>

<script>
import {HTTP} from './http-common';
import AmplifyStore from '../store/store';

export default {
    name: 'OrderPicturesPage',
    data () {
        return {
            pictures: [],
            selected: 'Ferne',
            categories: []
        }
    },
    computed: {
        pictures_length: function() {
            return this.pictures.length -1
        }
    },
    methods: {
        getCategories() {
            //this.$http.get('http://api.torstenniese.com:8000/v1/categories')
            HTTP.get(`categories`)
            .then(response =>{
                this.categories = response.data;
                var i;
                for (i = 0; i < this.categories.length; i++){
                    this.categories[i].value = this.categories[i].name;
                    this.categories[i].text = this.categories[i].name;
                }
            });
        },
        //add puts call to send array to local api
        categoryPictures(){
            //this.$http.get('http://api.torstenniese.com:8000/v1/pictures/category/' + this.selected)
            HTTP.get(`pictures-in-category/${this.selected}`)
                .then( response => {
                this.pictures = response.data;
            })
        },
        switchPosition(position, direction){
            this.pictures[position] = this.pictures.splice(position + direction, 1, this.pictures[position])[0];
        },
        onSubmit(e){
            e.preventDefault(); 

            let orderedPictures = this.pictures

            //TODO
            HTTP.put(
                `order-pictures`,
                JSON.stringify(orderedPictures),
                {headers: {Authorization: `Bearer ${AmplifyStore.state.user.signInUserSession.idToken.jwtToken}`}}
            ).then(reponse => {
                //check for 201 status
                alert("Bilder Reihenfolge aktualisiert")
            });
        }

    },
    created: function(){
        this.categoryPictures();
        this.getCategories();

    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
}
img {
    max-width: 200px; 
    float: left;
}

.order-pictures {
}

.picture-card {
    margin: 5px auto;
    width: 400px;
    border: solid 2px black;
    padding: 5px;
}

.picture-card:hover {
    background: #e5e5e5;
}

.order-picture {
    float: left;
    width: 48%;
    margin: auto;
}

.butn{
    padding-top: 5px;
    padding-bottom: 5px;
    display: block;
    border: solid 2px black;
    margin: 5px 5px;
}

.butn:hover {
    background: black;
    color: white;
}
</style>




// WEBPACK FOOTER //
// src/components/OrderPicturesPage.vue